export enum TitleCode {
  MR = "MR",
  MRS = "MRS",
}

export enum UseCaseCode {
  DIAGNOSTIC = "DIAGNOSTIC",
  REPAIR = "REPAIR",
  REPLACEMENT = "REPLACEMENT",
}

export enum UseCaseReasonCode {
  BROKEN_SCREEN = "BROKEN_SCREEN",
  REAR_BROKEN = "REAR_BROKEN",
  BROKEN_SIDE = "BROKEN_SIDE",
  BROKEN_REAR_CAMERA = "BROKEN_REAR_CAMERA",
  BROKEN_FRONT_CAMERA = "BROKEN_FRONT_CAMERA",
  DEVICE_BROKEN = "DEVICE_BROKEN",
  DEVICE_OFF = "DEVICE_OFF",
  OXIDATION = "OXIDATION",
  END_OF_RENTAL_RECOVERY_OF_GOOD = "END_OF_RENTAL_RECOVERY_OF_GOOD",
  FAILURE = "FAILURE",
}

export enum EventTypeCode {
  NEW_REQUEST = "NEW_REQUEST",
  AFTER_SALES_SERVICE = "AFTER_SALES_SERVICE",
}

export enum RoutingModeCode {
  POST_OFFICE = "POST_OFFICE",
  PICK_UP_POINT = "PICK_UP_POINT",
  PICK_UP_TRANSPORTATION = "PICK_UP_TRANSPORTATION",
}

export enum ServicePointTypeCode {
  CORNER = "CORNER",
  STORE = "STORE",
  SHOP_IN_SHOP = "SHOP_IN_SHOP",
}

export enum LogisticsModeCode {
  CENTRALIZATION = "CENTRALIZATION",
  PROXIMITY = "PROXIMITY",
  AT_HOME = "AT_HOME",
  PROXI_CENTRALIZATION = "PROXI_CENTRALIZATION",
}

export enum ObjectSpecificationCode {
  NEW_DEVICE = "NEW_DEVICE",
  USED_DEVICE = "USED_DEVICE",
  DEVICE_REFURBISHED_BY_MANUFACTURER = "DEVICE_REFURBISHED_BY_MANUFACTURER",
  ORIGINAL_DEVICE = "ORIGINAL_DEVICE",
  REPLACEMENT_DEVICE = "REPLACEMENT_DEVICE",
}

export enum AdditionalCharacteristicsType {
  FEATURES = "FEATURES",
}

export enum CharacteristicsType {
  NATURE = "NATURE",
}

export enum ActivityReturnStatus {
  OK = "OK",
  KO = "KO",
  ACCEPTED = "ACCEPTED",
  REFUSED = "REFUSED",
  PROVISION_OF_THE_CARRIER = "PROVISION_OF_THE_CARRIER",
  PROVISION_TO_THE_CUSTOMER = "PROVISION_TO_THE_CUSTOMER",
  RECEIVED_BY_CUSTOMER = "RECEIVED_BY_CUSTOMER",
  NOT_RECEIVED_BY_CUSTOMER = "NOT_RECEIVED_BY_CUSTOMER",
  FIXED = "FIXED",
  SWAPPED = "SWAPPED",
  IRREPARABLE = "IRREPARABLE",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  KO_DIAGNOSTIC = "KO_DIAGNOSTIC",
  REPLACEMENT_KO = "REPLACEMENT_KO",
  OK_DIAGNOSTIC = "OK_DIAGNOSTIC",
  IDENTICAL_REPLACEMENT = "IDENTICAL_REPLACEMENT",
  SIMILAR_REPLACEMENT_ISO = "SIMILAR_REPLACEMENT_ISO",
  OK_SEND_TO_MANUFACTURER = "OK_SEND_TO_MANUFACTURER",
  NOT_RECEIVED_LOSS_OF_TRANSPORT = "NOT_RECEIVED_LOSS_OF_TRANSPORT",
  RETENTION_BY_THE_INSURER = "RETENTION_BY_THE_INSURER",
  POSSIBLE_UPDATE = "POSSIBLE_UPDATE",
  LOSS = "LOSS",
}

export enum ResponseDetailsPropertiesKeyCode {
  SERVICE_POINT_CODE = "SERVICE_POINT_CODE",
  FEATURES = "FEATURES",
  EUROPEAN_ARTICLE_NUMBERING_CODE = "EUROPEAN_ARTICLE_NUMBERING_CODE",
  IMEI = "IMEI",
  MARKETBRANDNAME = "MARKETBRANDNAME",
  MODELNAME = "MODELNAME",
  DEVICE_NATURE = "DEVICE_NATURE",
  SERIALNUMBER = "SERIALNUMBER",
  PICK_UP_ADDRESS = "PICK_UP_ADDRESS",
  DELIVERY_ADDRESS = "DELIVERY_ADDRESS",
  TRAVEL_VOUCHER_LINK = "TRAVEL_VOUCHER_LINK",
  CARRIER_NAME = "CARRIER_NAME",
  TRACKING_NUMBER = "TRACKING_NUMBER",
  TRACKING_LINK = "TRACKING_LINK",
  DELIVERY_POINT_TYPE = "DELIVERY_POINT_TYPE",
  CERTIFICATE_OF_DESTRUCTION_IDENTIFIER = "CERTIFICATE_OF_DESTRUCTION_IDENTIFIER",
  TYPE_RECYCLING = "TYPE_RECYCLING",
  LOGISTICS_TARIFF = "LOGISTICS_TARIFF",
  SERVICE_PRICE = "SERVICE_PRICE",
  TYPE_OF_REPAIR = "TYPE_OF_REPAIR",
}

export enum RefuseMissionReasonCode {
  PROVIDER_NOT_AVAILABLE = "PROVIDER_NOT_AVAILABLE",
  NON_COMPLIANT = "NON_COMPLIANT",
}

export enum FailureReasonCode {
  LOST_PACKAGE = "LOST_PACKAGE",
  INCOMPLETE_DEVICE = "INCOMPLETE_DEVICE",
  ECONOMICALLY_IRREPARABLE_DEVICE = "ECONOMICALLY_IRREPARABLE_DEVICE",
  IRREPARABLE_DEVICE_UNAVAILABLE_COMPONENT = "IRREPARABLE_DEVICE_UNAVAILABLE_COMPONENT",
  TECHNICALLY_IRREPARABLE_DEVICE = "TECHNICALLY_IRREPARABLE_DEVICE",
  CHARACTERISTICS_NOT_MATCHED = "CHARACTERISTICS_NOT_MATCHED",
  MISSING_LOCK_CODE = "MISSING_LOCK_CODE",
  DAMAGE_INCONSISTENT_WITH_DECLARATION = "DAMAGE_INCONSISTENT_WITH_DECLARATION",
  UNPROVEN_DAMAGE = "UNPROVEN_DAMAGE",
  ECONOMICALLY_IRREPLACEABLE_DEVICE = "ECONOMICALLY_IRREPLACEABLE_DEVICE",
  CUSTOMER_DID_NOT_PICK_UP_THE_PACKAGE = "CUSTOMER_DID_NOT_PICK_UP_THE_PACKAGE",
  NOT_CONSISTENT_WITH_REQUESTED_DIAGNOSIS = "NOT_CONSISTENT_WITH_REQUESTED_DIAGNOSIS",
  SERIAL_NUMBER_NOT_MATCHED = "SERIAL_NUMBER_NOT_MATCHED",
  UNREADABLE_SERIAL_NUMBER = "UNREADABLE_SERIAL_NUMBER",
  DOES_NOT_LIVE_AT_THE_ADDRESS_GIVEN = "DOES_NOT_LIVE_AT_THE_ADDRESS_GIVEN",
  UNPROVEN_OXIDATION = "UNPROVEN_OXIDATION",
  UNPROVEN_FAILURES = "UNPROVEN_FAILURES",
  NO_STOCK = "NO_STOCK",
  REFUSED_BY_CUSTOMER = "REFUSED_BY_CUSTOMER",
  INCOMPLETE_ADDRESS = "INCOMPLETE_ADDRESS",
}

export enum AssignmentStatus {
  IN_PROGRESS = "IN_PROGRESS",
  EXECUTED = "EXECUTED",
  CANCELED = "CANCELED",
}

export enum AssignmentAcceptanceStatus {
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  UNAVAILABLE = "UNAVAILABLE",
}

export enum ActivityTypeCode {
  GENERATION_OF_THE_PREPAID_VOUCHER = "GENERATION_OF_THE_PREPAID_VOUCHER",
  DEVICE_RECEPTION = "DEVICE_RECEPTION",
  RETURN_OF_CONFORMITY = "RETURN_OF_CONFORMITY",
  RETURN_OF_GEOLOCATION = "RETURN_OF_GEOLOCATION",
  GEOLOCATION_DEACTIVATION_CONFIRMATION = "GEOLOCATION_DEACTIVATION_CONFIRMATION",
  BACK_FROM_DEVICE_SCAN = "BACK_FROM_DEVICE_SCAN",
  SERVICE_PROVIDER_ACTIONS = "SERVICE_PROVIDER_ACTIONS",
  DEVICE_MANUFACTURER_ACTIONS = "DEVICE_MANUFACTURER_ACTIONS",
  RETURN_DEVICE_TO_SENDER = "RETURN_DEVICE_TO_SENDER",
  CUSTOMER_ACKNOWLEDGMENT = "CUSTOMER_ACKNOWLEDGMENT",
  CARRIER_ACKNOWLEDGMENT = "CARRIER_ACKNOWLEDGMENT",
  ITEM_RECYCLING_REQUEST = "ITEM_RECYCLING_REQUEST",
  FORCE_THE_DECISION = "FORCE_THE_DECISION",
  DECISION_MAKING = "DECISION_MAKING",
  RECYCLING_PROCEDURE_ACKNOWLEDGMENT = "RECYCLING_PROCEDURE_ACKNOWLEDGMENT",
  LOSS_OF_PROVIDER_DEVICE = "LOSS_OF_PROVIDER_DEVICE",
  AFTER_SALES_SERVICE_REQUEST = "AFTER_SALES_SERVICE_REQUEST",
}

export enum MissionStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  DONE = "DONE",
}
